import React from "react";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import Commentbox from "../../components/common/Common/comment";
import { createPortal } from "react-dom";

const Commentdrawer = ({
  fromlist = false,
  photography = false,
  id,
  isOpen,
  toggleDrawer,
  setIsOpen,
}) => {
  return (
    <>
      {fromlist ? (
      
        createPortal(
          <Drawer
            open={isOpen}
            size={500}
            onClose={toggleDrawer}
            direction="right"
             className="bla bla bla"
            style={{
              zIndex: 9999 ,
              position: "fixed",
              top: 0,
              right: 0,
              height: "100vh",
              overflowX: "hidden",
               overscrollBehavior:"contain"
            }}
            enableOverlay={false}
          >
            <Commentbox id={id} setIsOpen={setIsOpen} />
          </Drawer>,
          document.body
        )
      ) : (
        <Drawer
          open={isOpen}
          size={500}
          onClose={toggleDrawer}
          direction="right"
          className="bla bla bla"
          style={{
            zIndex: photography ? 9999 : 101,
            position: "fixed", // ensure it overlays, not shifts layout
            top: 0,
            right: 0,
            height: "100vh", //
            overflowX: "hidden",
          }}
          enableOverlay={false}
        >
          <div>
            <Commentbox id={id} setIsOpen={setIsOpen} />
          </div>
        </Drawer>
      )}
    </>
  );
};

export default Commentdrawer;
